<app-pias-layout>
  <div pias-layout-content>
    <div id="download-resource-container" class="container-fluid">
      <div id="download-resource-header">
        <h5 class="page-header">Download Resources</h5>
      </div>
      @if (!showPreview) {
      <mat-accordion>
        <mat-expansion-panel [expanded]="this.isCategoryListNotEmpty()">
          <mat-expansion-panel-header (click)="$event.stopPropagation()">
            <mat-panel-title>
              <div class="path-pill">
                @for(category of this.resourceCategoryListSelectionPath; track category) {
                <span class="pill" [class.active]="this.categoryIdSelection() == category.folderid"
                  (click)="onPillClick($event, category)">{{ category.name }}</span>
                @if(this.categoryIdSelection() != category.folderid) {
                <span class="arrow">›</span>
                }
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="grid">
            @for(category of this.resourceCategoryListDataSource; track category) {
            <div class="Doc-card" (click)="this.__onCategorySelection(category)">
              <i class="bx bx-folder folder-icon"></i>
              <span class="card-title">{{ category.name }}</span>
            </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <br>
      <div id="download-resource-body" class="w-100">
        <div id="download-resource-filter-form" class="w-100">
          <form class="row align-items-start" [formGroup]="downloadResourceFg">
            <div class="col-sm-12 col-md-7 col-lg-5 col-xxl-5 m-0">
              <!-- <mat-form-field class="w-100">
                                <mat-label>Search keyword</mat-label>
                                <input matInput formControlName="searchKeyword" type="text"
                                    placeholder="Search by Keyword..." />
                            </mat-form-field> -->
              <div class="position-relative" style="max-width: 500px">
                <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                  style="background: #f0f0f0; color: #1c3a7a" formControlName="searchKeyword"
                  (keyup)="__applyDownloadResourceFilter()" placeholder="Search by keyword..." />

                <!-- Search icon -->
                <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                  style="color: #888888"></i>

                <!-- Clear button -->
                <button type="button" *ngIf="downloadResourceFg.get('searchKeyword')?.value"
                  class="btn position-absolute top-50 end-0 translate-middle-y me-3 p-0 border-0 bg-transparent"
                  (click)="clearSearch()">
                  <i class="fas fa-times" style="color: #888888"></i>
                </button>
              </div>
            </div>
          </form>
        </div>

        <mat-divider></mat-divider>
        <div id="download-resource-list-container">
          <!-- Sprinner -->
          @if(this.setResourceListSprinner()) {
          <div class="pias-spinner">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          }

          <mat-paginator [length]="downloadResourceLength" [pageSize]="downloadResourcePageSize" showFirstLastButtons  [pageIndex]=" downloadResourceCurrentPage"
            [pageSizeOptions]="[10, 20, 50]" (page)="__downloadResourceOnPageChange()">
          </mat-paginator>

          <div class="file-list-container mt-3">
            @for (drItem of this.downloadResourceListDataSource; track drItem) {
            <div class="card-container">
              <div class="icon-box">
                <span class="file-icon">
                  @if(['pdf'].includes(this.__getFileType(drItem.orgFileName))) {
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                  } @else if (['xlsb','xlsm','xlsx'].includes(this.__getFileType(drItem.orgFileName))) {
                  <i class="bi bi-file-earmark-spreadsheet-fill"></i>
                  } @else {
                  <i class="bi bi-file-earmark-text-fill"></i>
                  }
                </span>
              </div>

              <div class="content-box">
                <div class="meta">
                  <span class="type">{{ drItem.resourceCategoryPath }}</span>
                </div>

                <div class="title">{{ drItem.documentName }}</div>
                <div class="publish-date">{{ convertDate(drItem.uploadedDate) | date: 'dd-MMM-yyyy' }}</div>
              </div>

              <!-- @if(['pdf'].includes(this.__getFileType(drItem.resourceEndpoint))) {
              <div class="action-box">
                <a class="download-link" (click)="this.__printDownloadResource(drItem.resourceId)">
                  <mat-icon>print</mat-icon>
                </a>
              </div>
              } -->

              <!-- <div class="action-box">
                <a (click)="this.__userLogDocument(drItem.resourceId, drItem.resourceEndpoint)" class="download-link">
                  <mat-icon>download</mat-icon>
                </a>
              </div> -->
              <div class="action-box">
                <a class="download-link" (click)="this.__previewDownloadResource(drItem)">
                  <mat-icon>visibility</mat-icon>
                </a>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    <!-- Sticky preview panel — never overlays the checklist controls -->
    @if (showPreview) {

    <aside #previewPanel class="preview-panel" [class.is-fullscreen]="isFullscreen" role="region"
      aria-label="Document preview">

      <!-- Header: linked item + quick controls -->
      <div class="preview-header">
        <div class="preview-title">
          <mat-icon class="preview-title-icon">description</mat-icon>
          <div class="preview-title-text">
            <span class="preview-title-main">{{ currentFileName }}</span>
          </div>
        </div>

        <div class="preview-header-actions">
          <button mat-icon-button (click)="toggleFullscreen()"
            [matTooltip]="isFullscreen ? 'Exit full screen' : 'Full screen'">
            <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
          <button mat-icon-button (click)="closePreview()" matTooltip="Close preview (Esc)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Scrollable / pannable preview surface -->
      <div class="preview-content">
        <iframe [src]="selectedDocument" class="preview-pdf" title="Document preview"></iframe>
      </div>
    </aside>
    }
  </div>
</app-pias-layout>